module.exports = __webpack_public_path__ + "static/step-1-1d4d3dc06682baddefe60cbab9419072.svg";